import { collection, getDocs, query, where } from 'firebase/firestore';
import uniqid from 'uniqid';
import { User, Worker } from '../../apiTypes';
import { db } from '../../firebase';
import { createBatch } from '../../utils/api';

type Props = {
  worker: Worker;
  cafeSlug: string;
};

export const createWorker = async ({ worker, cafeSlug }: Props) => {
  const batch = createBatch();
  let userId: string | null = null;

  if (worker.email) {
    const qByEmail = query(collection(db, 'users'), where('email', '==', worker.email));
    const querySnapshotByEmail = await getDocs(qByEmail);

    if (querySnapshotByEmail.size > 0) {
      querySnapshotByEmail.forEach((doc) => {
        userId = doc.id;
      });
    }
  }

  if (worker.phone) {
    const qByPhone = query(collection(db, 'users'), where('phone', '==', worker.phone));
    const querySnapshotByPhone = await getDocs(qByPhone);

    if (querySnapshotByPhone.size > 0) {
      querySnapshotByPhone.forEach((doc) => {
        userId = doc.id;
      });
    }
  }

  if (!userId) {
    batch.set<User>(`users/${uniqid()}`, {
      displayName: worker.name,
      photoURL: worker.photoUrl || '',
      email: worker.email,
      phone: worker.phone,
    });
  }

  batch.set<Worker>(`cafes/${cafeSlug}/workers/${uniqid()}`, worker);

  await batch.commit();
};
